import React from "react";

const Announcements = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 2.25V5.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 2.25V5.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11.25C12 10.6533 12.2371 10.081 12.659 9.65901C13.081 9.23705 13.6533 9 14.25 9C14.8467 9 15.419 9.23705 15.841 9.65901C16.2629 10.081 16.5 10.6533 16.5 11.25C16.5 14.25 12 16.5 12 16.5C12 16.5 7.5 14.25 7.5 11.25C7.5 10.6533 7.73705 10.081 8.15901 9.65901C8.58097 9.23705 9.15326 9 9.75 9C10.3467 9 10.919 9.23705 11.341 9.65901C11.7629 10.081 12 10.6533 12 11.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Announcements;
